module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/132-bosnia-and-herzegovina-aa0e41c125db01d97a0fbea560bcc363.svg";